import { FormControl, MenuItem, Select } from "@mui/material";
import { useLanguage } from "../../contexts/LanguageContext";
import translations from "./LanguageSelector.translations.json";

type SupportedLanguage = keyof typeof translations;

const LANGUAGES = [
  { value: "fr", label: "Francais" },
  { value: "en", label: "English" },
  { value: "mg", label: "Malagasy" },
] as const;

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const content = translations[language as SupportedLanguage] || translations.en;

  return (
    <FormControl
      size="small"
      sx={{
        width: { xs: '100%', sm: 'auto' },
        minWidth: { xs: '100%', sm: 130 },
      }}
    >
      <Select
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        variant="outlined"
        displayEmpty
        renderValue={(selected) => {
          const current = LANGUAGES.find((item) => item.value === selected);
          return current ? current.label : content.label;
        }}
        sx={{
          color: "#ffffff",
          borderRadius: "999px",
          backgroundColor: "rgba(59, 130, 246, 0.12)",
          border: "1px solid rgba(148, 163, 184, 0.35)",
          boxShadow: "none",
          minHeight: 38,
          paddingRight: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiSelect-select": {
            py: 0.75,
            px: 2,
            fontWeight: 600,
          },
          "& .MuiSelect-icon": {
            color: "#ffffff",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: "#161d2b",
              color: "#ffffff",
              "& .MuiMenuItem-root": {
                px: 2,
                py: 1,
              },
              "& .MuiMenuItem-root:hover": { bgcolor: "rgba(59, 130, 246, 0.2)" },
            },
          },
        }}
      >
        {LANGUAGES.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {content[item.value]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector;